import { LLM } from '@/types'
import i18next from 'i18next'

import { CATEGORIES } from '../categories'

const OPENAI_PLATORM_LINK = 'https://platform.openai.com/docs/overview'

const GPTRealtime: LLM = {
  modelId: 'gpt-realtime',
  modelName: 'GPT Realtime',
  provider: 'openai',
  hostedId: 'gpt-realtime',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: false,
  tools: true,
  tier: 'pro',
  supportsStreaming: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt_realtime.description',
      'Default realtime voice model for low-latency speech conversations.'
    ),
  categories: [CATEGORIES.TECHNOLOGY]
}

const GPTRealtimeMini: LLM = {
  modelId: 'gpt-realtime-mini-2025-12-15',
  modelName: 'GPT Realtime mini',
  provider: 'openai',
  hostedId: 'gpt-realtime-mini-2025-12-15',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: false,
  tools: true,
  tier: 'pro',
  supportsStreaming: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt_realtime_mini.description',
      'Fast realtime voice model for low-latency speech conversations.'
    ),
  categories: [CATEGORIES.TECHNOLOGY]
}

const GPTRealtime2: LLM = {
  modelId: 'gpt-realtime-2',
  modelName: 'GPT Realtime 2',
  provider: 'openai',
  hostedId: 'gpt-realtime-2',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: false,
  tools: true,
  tier: 'ultra',
  supportsStreaming: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt_realtime_2.description',
      'Realtime voice model with stronger reasoning for complex voice agents.'
    ),
  categories: [CATEGORIES.TECHNOLOGY, CATEGORIES.REASONING]
}

const GPT4O: LLM = {
  modelId: 'gpt-4o-2024-11-20',
  modelName: 'GPT-4o',
  provider: 'openai',
  hostedId: 'gpt-4o-2024-11-20',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'pro',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  description: () => i18next.t('models.providers.openai.gpt4o.description'),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 2.5,
    outputCost: 10.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING
  ]
}

const GPT4O_Mini: LLM = {
  modelId: 'gpt-4o-mini',
  modelName: 'GPT-4o mini',
  provider: 'openai',
  hostedId: 'gpt-4o-mini',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'free',
  new: false,
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  description: () => i18next.t('models.providers.openai.gpt4o_mini.description'),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.15,
    outputCost: 0.6
  },
  categories: [CATEGORIES.TECHNOLOGY, CATEGORIES.SCIENCE, CATEGORIES.PROGRAMMING]
}

const O1: LLM = {
  modelId: 'o1-2024-12-17',
  modelName: 'o1',
  provider: 'openai',
  hostedId: 'o1-2024-12-17',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'ultra',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: false,
  description: () => i18next.t('models.providers.openai.o1.description'),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 15,
    outputCost: 60
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const O1_Mini: LLM = {
  modelId: 'o1-mini',
  modelName: 'o1 Mini',
  provider: 'openai',
  hostedId: 'o1-mini',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: false,
  tools: false,
  tier: 'pro',
  supportsStreaming: false,
  description: () => i18next.t('models.providers.openai.o1_mini.description'),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 3,
    outputCost: 12
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const O3_Mini: LLM = {
  modelId: 'o3-mini',
  modelName: 'o3 Mini',
  provider: 'openai',
  hostedId: 'o3-mini',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: false,
  tools: true,
  tier: 'pro',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  description: () => i18next.t('models.providers.openai.o3_mini.description'),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 3,
    outputCost: 12
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT41: LLM = {
  modelId: 'gpt-4.1',
  modelName: 'GPT-4.1',
  provider: 'openai',
  hostedId: 'gpt-4.1',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'pro',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt41.description',
      "GPT-4.1 is OpenAI's most advanced model, offering exceptional reasoning, coding, and creative capabilities. With a 1M token context window, it excels at complex analysis, technical writing, and multi-step problem solving. Perfect for research, development, and professional applications."
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 2.0,
    outputCost: 8.0
  },
  new: false,
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT41_Mini: LLM = {
  modelId: 'gpt-4.1-mini',
  modelName: 'GPT-4.1 mini',
  provider: 'openai',
  hostedId: 'gpt-4.1-mini',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'pro',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: false,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt41_mini.description',
      "GPT-4.1 mini offers a balanced combination of performance and efficiency. With the same 1M token context window as its larger counterpart, it's ideal for everyday tasks, content creation, and general assistance. Great for developers, writers, and professionals who need reliable AI support."
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.4,
    outputCost: 1.6
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING
  ]
}

const GPT41_Nano: LLM = {
  modelId: 'gpt-4.1-nano',
  modelName: 'GPT-4.1 nano',
  provider: 'openai',
  hostedId: 'gpt-4.1-nano',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'free',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: false,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt41_nano.description',
      'GPT-4.1 nano is a lightweight yet capable model perfect for casual use and learning. With a 1M token context window, it handles basic queries, simple coding tasks, and general assistance efficiently. An excellent starting point for exploring AI capabilities.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.1,
    outputCost: 0.4
  },
  categories: [CATEGORIES.TECHNOLOGY, CATEGORIES.PROGRAMMING, CATEGORIES.PROGRAMMING_SCRIPTING]
}

const GPT5: LLM = {
  modelId: 'gpt-5',
  modelName: 'GPT-5',
  provider: 'openai',
  hostedId: 'gpt-5',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'pro',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: false,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5.description',
      "GPT-5 is OpenAI's latest flagship model featuring advanced reasoning capabilities. With configurable reasoning effort and verbosity, it provides unparalleled performance for complex tasks, analysis, and creative work."
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 10.0,
    outputCost: 30.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT5_1: LLM = {
  modelId: 'gpt-5.1',
  modelName: 'GPT-5.1',
  provider: 'openai',
  hostedId: 'gpt-5.1',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'pro',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: false,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_1.description',
      "GPT-5.1 is OpenAI's newest flagship model, part of the GPT-5 family. Our most intelligent model yet, with new 'none' reasoning setting for faster responses, increased steerability, and new tools for coding use cases."
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 10.0,
    outputCost: 30.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT5_1_CODEX_MAX: LLM = {
  modelId: 'gpt-5.1-codex-max',
  modelName: 'GPT-5.1 Codex Max',
  provider: 'openai',
  hostedId: 'gpt-5.1-codex-max',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'ultra',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_1_codex_max.description',
      'GPT-5.1 Codex Max is specifically designed for companies building interactive coding products. It offers the full spectrum of coding tasks with faster, more capable, and more token-efficient performance.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 15.0,
    outputCost: 45.0
  },
  categories: [
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.REASONING
  ]
}

const GPT5_2: LLM = {
  modelId: 'gpt-5.2',
  modelName: 'GPT-5.2',
  provider: 'openai',
  hostedId: 'gpt-5.2',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'ultra',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_2.description',
      "GPT-5.2 is OpenAI's best general-purpose model, part of the GPT-5 flagship model family. Our most intelligent model yet for both general and agentic tasks, with improvements in reasoning, instruction following, accuracy, token efficiency, multimodality, code generation, tool calling, and context management."
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 15.0,
    outputCost: 45.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT5_2_CHAT_LATEST: LLM = {
  modelId: 'gpt-5.2-chat-latest',
  modelName: 'GPT-5.2 Chat Latest',
  provider: 'openai',
  hostedId: 'gpt-5.2-chat-latest',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'ultra',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_2_chat_latest.description',
      'GPT-5.2 Chat Latest is the model powering ChatGPT, featuring advanced intelligence with a knowledge cutoff of August 2025. It provides more accurate and useful answers with more relevant examples and context.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 15.0,
    outputCost: 45.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT5_2_PRO: LLM = {
  modelId: 'gpt-5.2-pro',
  modelName: 'GPT-5.2 Pro',
  provider: 'openai',
  hostedId: 'gpt-5.2-pro',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'ultra',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_2_pro.description',
      'GPT-5.2 Pro uses more compute to think harder and provide consistently better answers. Ideal for tough problems that may take longer to solve but require harder thinking.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 20.0,
    outputCost: 60.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT5_4: LLM = {
  modelId: 'gpt-5.4',
  modelName: 'GPT-5.4',
  provider: 'openai',
  hostedId: 'gpt-5.4',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'ultra',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: false,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_4.description',
      'GPT-5.4 remains available — prefer GPT-5.6 Sol/Terra for new work.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 2.5,
    outputCost: 15.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT5_6_SOL: LLM = {
  modelId: 'gpt-5.6-sol',
  modelName: 'GPT-5.6 Sol',
  provider: 'openai',
  hostedId: 'gpt-5.6-sol',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'ultra',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_6_sol.description',
      'GPT-5.6 Sol is OpenAI’s current flagship (gpt-5.6 alias) for professional and agentic work.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 4.0,
    outputCost: 20.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT5_6_TERRA: LLM = {
  modelId: 'gpt-5.6-terra',
  modelName: 'GPT-5.6 Terra',
  provider: 'openai',
  hostedId: 'gpt-5.6-terra',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'pro',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_6_terra.description',
      'GPT-5.6 Terra balances intelligence and cost — the mid-tier default for most workloads.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 2.0,
    outputCost: 12.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT5_6_LUNA: LLM = {
  modelId: 'gpt-5.6-luna',
  modelName: 'GPT-5.6 Luna',
  provider: 'openai',
  hostedId: 'gpt-5.6-luna',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'free',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: true,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_6_luna.description',
      'GPT-5.6 Luna is optimized for cost-sensitive, high-volume workloads.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.25,
    outputCost: 2.0
  },
  categories: [CATEGORIES.TECHNOLOGY, CATEGORIES.PROGRAMMING, CATEGORIES.REASONING]
}

const GPT5_5: LLM = {
  modelId: 'gpt-5.5',
  modelName: 'GPT-5.5',
  provider: 'openai',
  hostedId: 'gpt-5.5',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'ultra',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: false,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_5.description',
      'GPT-5.5 remains available on the API — prefer GPT-5.6 Sol for new work.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 5.0,
    outputCost: 30.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.ACADEMIA,
    CATEGORIES.LEGAL,
    CATEGORIES.FINANCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT5_Mini: LLM = {
  modelId: 'gpt-5-mini',
  modelName: 'GPT-5 mini',
  provider: 'openai',
  hostedId: 'gpt-5-mini',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'free',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: false,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_mini.description',
      'GPT-5 mini offers advanced reasoning in a more efficient package. Perfect for tasks requiring enhanced thinking capabilities while maintaining cost-effectiveness.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 2.0,
    outputCost: 8.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.SCIENCE,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

const GPT5_Nano: LLM = {
  modelId: 'gpt-5-nano',
  modelName: 'GPT-5 nano',
  provider: 'openai',
  hostedId: 'gpt-5-nano',
  platformLink: OPENAI_PLATORM_LINK,
  imageInput: true,
  tools: true,
  tier: 'free',
  defaultTools: ['b3f07a6e-5e01-423e-9f06-ee51830608be', 'b3f07a6e-5e01-423e-1f05-ee51830608gf'],
  supportsStreaming: true,
  new: false,
  description: () =>
    i18next.t(
      'models.providers.openai.gpt5_nano.description',
      'GPT-5 nano brings reasoning capabilities to an accessible model. Ideal for learning and experimentation with advanced AI reasoning features.'
    ),
  pricing: {
    currency: 'USD',
    unit: '1M tokens',
    inputCost: 0.5,
    outputCost: 2.0
  },
  categories: [
    CATEGORIES.TECHNOLOGY,
    CATEGORIES.PROGRAMMING,
    CATEGORIES.PROGRAMMING_SCRIPTING,
    CATEGORIES.REASONING
  ]
}

export const OPENAI_LLM_LIST: LLM[] = [
  GPT5_6_SOL,
  GPT5_6_TERRA,
  GPT5_6_LUNA,
  GPT5_5,
  GPT5_4,
  GPTRealtime2,
  GPTRealtime,
  GPTRealtimeMini,
  // Legacy OpenAI (still callable; hidden by default in picker)
  GPT5_2,
  GPT5_2_CHAT_LATEST,
  GPT5_2_PRO,
  GPT5_1,
  GPT5_1_CODEX_MAX,
  GPT5,
  GPT5_Mini,
  GPT5_Nano,
  GPT41,
  GPT41_Mini,
  GPT41_Nano,
  GPT4O,
  GPT4O_Mini,
  O1
]
